import React, { useState } from "react";
import { Field } from "formik";
import { Chip, Grid, IconButton, Box, makeStyles, TextField } from "@material-ui/core";
import formFieldChipStyle from "./formFieldChipStyle";
import { Add as AddIcon } from "@material-ui/icons";

const useStyles = makeStyles((theme) => formFieldChipStyle(theme));

const FormFieldChip = ({ name,  ...rest }) => {
  const [text, setText] = useState("");
  const classes = useStyles();

  const handleInput = ({ target }) => {setText(target.value.toUpperCase())}

  const buildChips = (values = [], setFieldValue) => values.map(value => (
    <Grid item key={value}>
      <Chip
        className={classes.chip}
        label={value}
        onDelete={() => {
          const filtered = values.filter(val => val !== value)
          setFieldValue(name, filtered)
        }}
      />
    </Grid>
  ))

  const onSubmit = (setFieldValue, values = []) => {
    if (!values.includes(text)) {
      setFieldValue(name, [...values, text])
      setText("")
    }
  }

  return (
    <Field name={name}>{({ field, form }) => (
      <Grid container>
        <Grid item xs={12}>
          <Box className={classes.form}>
            <TextField
              {...rest}
              className={classes.input}
              variant="outlined"
              value={text}
              onSubmit={(e) => e.preventDefault()}
              onChange={handleInput}
            />

            <IconButton
              color="primary"
              className={classes.addButton}
              onClick={() => onSubmit(form.setFieldValue, field.value)}
              aria-label="directions"
            >
              <AddIcon />
            </IconButton>
          </Box>
        </Grid>

        <Grid container item>
          {buildChips(field.value, form.setFieldValue)}
        </Grid>
      </Grid>
    )}</Field>
  );
}

export default FormFieldChip
